import { Avatar, Paper, Theme, styled } from '@mui/material';

interface ProgramSectionCourseInfoWrapProps {
	isCollapsed?: boolean;
	isSelfStudyProgram?: boolean;
}

export const ProgramSectionCourseInfoWrap = styled(Paper, {
	shouldForwardProp: (prop) => prop !== 'isCollapsed' && prop !== 'isSelfStudyProgram',
})<ProgramSectionCourseInfoWrapProps>(
	({
		isCollapsed,
		isSelfStudyProgram = false,
		theme,
	}: {
		isCollapsed?: boolean;
		isSelfStudyProgram?: boolean;
		theme: Theme;
	}) => ({
		borderRadius: '20px',
		padding: '16px',
		gap: '8px',
		marginBottom: '16px',
		transition: 'box-shadow 1s',
		transitionDelay: '0.5s',

		...(isCollapsed && { boxShadow: 'none', transitionDelay: '0s', transition: 'none' }),

		display: 'grid',
		gridTemplateColumns: isSelfStudyProgram ? '1fr' : '1fr 1fr 0.7fr',

		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: '1fr',
		},

		[theme.breakpoints.down('sm')]: {
			background: 'none',
			boxShadow: 'none',
			padding: '0px',
		},
	}),
);

export const StyledProgramSectionCourseTeacherInfo = styled(Paper)({
	display: 'flex',
	alignItems: 'center',
	padding: '8px 16px 8px 16px',
	gap: '12px',
	borderRadius: '10px',
	flexWrap: 'wrap',

	order: 0,

	gridColumn: '1 / -1',
});

export const StyledProgramSectionTeacherAvatar = styled(Avatar)({
	borderRadius: '50%',
	width: '48px',
	height: '48px',
});

export const StyledProgramSectionBooksList = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	overflow: 'auto',
	maxHeight: '175px',
	paddingRight: '4px',
	boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',

	// Since this block takes up 0.7fr compared to the others,
	// we need to get 0.7 of the width of the first block + paddings,
	// in which the layout is changed during the container
	// request so that we do not use js here
	'@container (max-width: 201px)': {
		maxHeight: '250px',
	},
});
